import HttpClient from '../HttpClient';

class CookbookService extends HttpClient {

    ressourceUrl = '/cookbook';

    constructor() {
        super();
    }

    async getPagedData(page) {
        return (await this.getPaged(this.ressourceUrl, page)).data;
    }

    async getData(id) {
        return (await this.get(`${this.ressourceUrl}/${id}`)).data;
    }

    async create(data) {
        return (await this.post(this.ressourceUrl, data));
    }
}

export default new CookbookService();
